/* eslint-disable no-unused-vars */
import cn from 'classnames';
import { ChangeEvent, KeyboardEvent, ReactNode } from 'react';
import styles from './bet-input.module.scss';

export interface IBetInputProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  onEnterDown?: () => void;
  min?: string;
  max?: string;
  step?: string;
  name?: string;
  icon?: ReactNode;
  placeholder?: string;
  reversed?: boolean;
  className?: string;
}

const BetInput = ({
  className = '',
  reversed = false,
  icon,
  onEnterDown,
  ...rest
}: IBetInputProps): JSX.Element => {
  const handleEnter = (e: KeyboardEvent<HTMLInputElement>): void => {
    e.key === 'Enter' && onEnterDown?.();
  };

  /* ClassNames */
  const classNames = cn(styles.container, className, {
    [styles.reversed]: reversed,
  });

  return (
    <div className={classNames}>
      <input type="number" {...rest} onKeyDown={handleEnter} />
      {icon}
    </div>
  );
};

export default BetInput;
